import { esc, nf0, nf1, num } from '../calc/format.js';
import { MIN_RECEIPTS, basketCandidates, basketIndex, boughtWith, topPairs } from '../calc/basket.js';
import { el } from './dom.js';
import { helpButton } from './help.js';
import { state } from './state.js';

/* --------------------------------------------------------------------------
   Köps ofta tillsammans

   En liggande stapellista: för vald artikel, vad som oftast ligger i samma
   köp. Stapeln är andelen av köpen med artikeln, skalad mot den längsta så
   att skillnaderna syns; siffran bredvid är den riktiga andelen. Under
   står hur många köp det är och hur mycket oftare än vanligt.

   Bredvid står de par som oftast köps tillsammans i urvalet. Ett klick på
   ett par visar den första artikelns lista.

   Beräkningen i calc/basket.js. Korgarna räknas en gång per urval.
   -------------------------------------------------------------------------- */

let cache = {view: null, index: null, candidates: [], pairs: []};

function indexFor(view){
  if(cache.view !== view){
    const index = basketIndex(view);
    cache = {view, index, candidates: basketCandidates(index), pairs: topPairs(index)};
  }
  return cache;
}

const times = v => (v >= 10 ? nf0 : nf1).format(v);
const share = v => (v >= 10 || v === 0 ? nf0 : nf1).format(v) + ' %';

/** Väljer artikeln i listan och ritar om. focus flyttar fokus till valet. */
export function selectBasketItem(key, focus = false){
  state.basketKey = key;
  renderBasket(state.view.length > 0);
  if(focus) el('basketItem').focus();
}

export function renderBasket(has){
  el('basketHelp').innerHTML = helpButton('korg');
  const sel = el('basketItem'), list = el('basketList'), lead = el('basketLead'), pairs = el('basketPairs');
  const {index, candidates, pairs: top} = has ? indexFor(state.view) : {index: null, candidates: [], pairs: []};
  el('basketTools').hidden = candidates.length === 0;
  el('basketPairsBox').hidden = candidates.length === 0;

  if(!candidates.length){
    sel.innerHTML = '';
    list.innerHTML = '';
    lead.innerHTML = has
      ? `För få köp för att se mönster. En artikel behöver finnas i minst ${num(MIN_RECEIPTS)} köp i urvalet.`
      : 'Inga kvitton i urvalet.';
    pairs.innerHTML = '';
    return;
  }

  // Behåll valet om artikeln finns kvar i urvalet, annars den första
  // artikeln i det starkaste paret, annars den som köps oftast
  const keys = new Set(candidates.map(c => c.key));
  if(!keys.has(state.basketKey)) state.basketKey = top.length ? top[0].a : candidates[0].key;
  const key = state.basketKey;

  const sorted = [...candidates].sort((a, b) => a.name.localeCompare(b.name, 'sv'));
  sel.innerHTML = sorted.map(c =>
    `<option value="${esc(c.key)}"${c.key === key ? ' selected' : ''}>${esc(c.name)} (${esc(num(c.receipts))} köp)</option>`).join('');

  const r = boughtWith(index, key);
  if(!r.items.length){
    lead.innerHTML = `Ingen artikel köps tydligt oftare tillsammans med <b>${esc(r.name)}</b> än annars.`;
    list.innerHTML = '';
  }else{
    lead.innerHTML = `I <b>${esc(num(r.receipts))}</b> köp med <b>${esc(r.name)}</b> fanns också:`;
    const longest = r.items[0].share;
    list.innerHTML = r.items.map(i => `<li class="bar-item">
        <div class="bar-row"><span class="bar-fill" style="width:${Math.max(2, i.share / longest * 100).toFixed(1)}%" aria-hidden="true"></span>
          <span class="bar-name">${esc(i.name)}</span><span class="bar-val">${esc(share(i.share))}</span></div>
        <div class="bar-meta">${esc(num(i.together))} köp · ${esc(times(i.lift))} gånger så ofta som vanligt</div>
      </li>`).join('');
  }

  pairs.innerHTML = top.length
    ? top.map(p => `<li><button type="button" class="pair${p.a === key ? ' is-current' : ''}" data-key="${esc(p.a)}">
          <span class="pair-names">${esc(p.aName)} <span aria-hidden="true">+</span><span class="vishidden">och</span> ${esc(p.bName)}</span>
          <span class="pair-meta">${esc(num(p.together))} köp · ${esc(times(p.lift))} gånger så ofta</span>
        </button></li>`).join('')
    : '<li class="pair-empty">Inga artiklar köps tydligt oftare tillsammans i urvalet.</li>';
}
